import { http } from '@/shared/api';
import type {
  AuthApiLoginData,
  AuthQrTicketData,
} from '../model/auth-session';

// 接口路径 + 业务参数的薄适配层。
// 统一请求层已负责响应归一化，调用方按 ApiResponse.code 处理即可。

export function loginByVisitor(visitorId: string) {
  return http.post<AuthApiLoginData>('/zs/user/login', {
    login_type: 10,
    visitor: visitorId,
    register_code: '',
    token: '',
  });
}

export function loginByToken(token: string, signatureUuid = '') {
  return http.post<AuthApiLoginData>('/zs/user/login', {
    login_type: 999,
    token,
  }, signatureUuid.trim() ? { signatureUuid } : undefined);
}

interface SharedAuthLoginParams {
  token: string;
  uuid: string;
  opTeam?: string;
}

export function loginBySharedAuth(params: SharedAuthLoginParams) {
  return http.post<AuthApiLoginData>('/zs/user/login', {
    login_type: 999,
    token: params.token,
    op_team: params.opTeam ?? '',
  }, params.uuid.trim() ? { signatureUuid: params.uuid } : undefined);
}

export function requestWechatQrTicket(token: string) {
  return http.post<AuthQrTicketData>('/zs/user/getPcLoginQR', {
    token,
  });
}

export function pollWechatQrLogin(ticket: string, token: string) {
  return http.post<AuthApiLoginData>('/zs/user/refreshWxLogin', {
    ticket,
    token,
  });
}

export function createWechatQrImageUrl(ticket: string) {
  return `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${encodeURIComponent(ticket)}`;
}
